

































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import { AuditOption } from '~/models/audit/option'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { shuffleArray } from '~/utils/array'
import { defineComponentTranslations } from '~/utils/i18n'
import CInfoTooltip from '~/components/shared/configurable/info/CInfoTooltip.vue'
import { useI18n } from '~/compositions/i18n'
import { ciInfoCircle } from '~/icons/source/solid/info-circle'

export default defineComponent({
  components: { CInfoTooltip },
  props: {
    options: {
      type: Array as PropType<AuditOption[]>,
      required: true
    },
    limit: {
      type: Number,
      required: false,
      default: 5
    },
    checkColorClass: {
      type: String,
      required: false,
      default: 'tw-text-primary'
    },
    noLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    dotsClass: {
      type: String,
      required: false,
      default: '!tw-mt-2'
    }
  },
  setup(props) {
    const { options, limit, noLimit } = toRefs(props)

    const { t } = useI18n()

    const optionsToShow = computed(() => {
      if (noLimit.value) {
        return options.value
      }

      const refinishing = options.value.find(o => o.name === 'refinishing')

      if (refinishing) {
        return shuffleArray([
          refinishing,
          ...options.value
            .filter(o => o.name !== refinishing.name)
            .slice(0, limit.value - 1)
        ])
      }
      return options.value.slice(0, limit.value)
    })
    return { optionsToShow, faCheck, t, ciInfoCircle }
  },
  i18n: defineComponentTranslations({
    refinishing_tooltip: {
      en:
        'Refinishing is checked visually or with the help of technical means (paint thickness gauge), however, it does not guarantee the absence of accidents for the inspected vehicle.',
      el:
        'Η φανοποιία ελέγχεται οπτικά ή με τη βοήθεια τεχνικών μέσων (μετρητής πάχους βαφής) ωστόσο δεν εγγυάται η μη ύπαρξη ατυχημάτων για το ελεγχόμενο όχημα.'
    }
  })
})
